/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  checkValidMobileNumber,
} from '../../../shared/constants/Constants';
import AppButton from '../../../shared/components/app-button/AppButton';
import HotelEmailContent from './HotelEmailContent';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import { getUserDetails } from '../../../api/profileApi';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { countryMobileCodes } from '../../../shared/constants/CountryOptions';
import AppSelect from '../../../shared/components/app-select/AppSelect';
// import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';

const getLabel = (country) => {
  return (
    <div
      className="flex justify-between items-center gap-2"
      title={country.name}
    >
      <div className="flex items-center gap-1 flex-row">
        <img
          style={{ width: '15px', height: '15px', display: 'inline' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
        <span className="text-[12px]">{country.dial_code}</span>
      </div>
    </div>
  );
};

const mobileCodes = countryMobileCodes.map((country) => ({
  label: `${country.name} ${country.dial_code}`,
  value: country.dial_code,
  country,
}));

function HotelWhatsAppShareModal({ onSend, shortListedHotels, searchRequest }) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [showBreakup, setShowBreakup] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [validationError, setValidationError] = useState(false);

  const [userDetails, setUserDetails] = useState(null);
  const [countryCode, setCountryCode] = useState(appConfig.appMobileCode);
  const [countryCodeOptions] = useState(mobileCodes);

  const getUserData = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setUserDetails(User);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseFloat(markUpToBeAdded, 10);
    return parseFloat(val, 10) + markup;
  };

  const handleSendWhatsapp = () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    const numberWithCountryCode = (countryCode + whatsappNumber).replace(
      '+',
      '',
    );
    setIsLoading(true);
    let fromEmail = '';
    let contactNum = '';
    let companyName = '';
    if (!isEmpty(userDetails)) {
      fromEmail = userDetails.ContactEmail;
      contactNum = userDetails.ContactNumber;
      companyName = userDetails.Company;
    }
    let msg = '';
    const hotelEmoji = '🏨';
    msg += `Hotels in ${searchRequest.searchQuery.city}, ${
      searchRequest.searchQuery.country
    } for ${
      searchRequest.searchQuery.totalPeople
    } People \nCheck in: ${formatDate(
      getNewDate(searchRequest.searchQuery.checkInSearch),
      DATE_MONTH_YEAR_VIEW_FORMAT,
    )}\nCheck out: ${formatDate(
      getNewDate(searchRequest.searchQuery.checkOutSearch),
      DATE_MONTH_YEAR_VIEW_FORMAT,
    )}\n\n`;

    shortListedHotels.forEach((hotel) => {
      msg += `${hotelEmoji}${hotel.propertyName}\nAddress: ${
        hotel.shortaddr
      }\n\n ${
        showBreakup
          ? `Price: ${appConfig?.appCurrency} ${getAmount(hotel.maxPrice)}`
          : ''
      } for 1 Night\n\n `;
      msg += '------------------------------------------\n';
    });
    msg += `👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻\n\nThank you for choosing ${companyName}\nIn case of any urgent support : \n`;
    msg += `☎ Contact : ${contactNum}\n✉ Email  : ${fromEmail}\n`;
    onSend(numberWithCountryCode, msg);
  };
  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div className="d-flex align-items-center gap-3 mb-1">
        <AppRadioInput
          id="true"
          name="showBrakup"
          labelText="With Fare"
          value=""
          onChange={() => setShowBreakup(true)}
          checked={showBreakup}
        />
        <AppRadioInput
          id="false"
          name="showBrakup"
          labelText="Without Fare"
          value=""
          onChange={() => setShowBreakup(false)}
          checked={!showBreakup}
        />
      </div>
      <Row className="spacing-16 my-2">
        <Col lg={2} md={2} sm={6} xs={6}>
          <AppSelect
            className="country-codes-input"
            name="countryCode"
            id="countryCode"
            label="Country code"
            placeholder=""
            required
            selectedValue={countryCode}
            options={countryCodeOptions}
            formatOptionLabel={(option) => getLabel(option.country)}
            isClearable={false}
            errorText={validationError && 'Please select country code'}
            onSelect={(value) =>
              value !== null ? setCountryCode(value.value) : setCountryCode('')
            }
          />
        </Col>
        <Col lg={6} md={6} sm={6} xs={12}>
          <AppNumberInput
            label="WhatsApp Number"
            name="whatsappNumber"
            placeholderText=""
            required
            value={whatsappNumber}
            onChange={(d) => setWhatsappNumber(d)}
            errorText={validationError && 'Please Enter Mobile Number'}
          />
          {checkValidMobileNumber(whatsappNumber) && validationError && (
            <small className="app-error-text">Enter Valid Number</small>
          )}
        </Col>
        {getValueFromAppConfig('ISCORPORATECLIENT') !== 'true' &&
          showBreakup && (
            <Col lg={4} md={4} sm={6} xs={12}>
              <AppNumberInput
                name="markUpToBeAdded"
                label={
                  appConfig?.companyName === 'Aman Travels'
                    ? 'Transaction fee'
                    : 'Markup'
                }
                value={markUpToBeAdded}
                onChange={(d) => setMarkupToBeAdded(d)}
              />
            </Col>
          )}
        <Col lg={12} md={12} sm={12} xs={12}>
          <div className="overflow-auto hide-in-mobile">
            <HotelEmailContent
              hotelList={shortListedHotels}
              searchQuery={searchRequest.searchQuery}
              showInput
              showBreakup={showBreakup}
              markUpToBeAdded={markUpToBeAdded}
            />
          </div>
        </Col>
        <Col
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="d-flex justify-content-end"
        >
          <div>
            <AppButton
              btnText="Send WhatsApp"
              onClick={handleSendWhatsapp}
              variant="primary"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

HotelWhatsAppShareModal.propTypes = {
  onSend: PropTypes.func.isRequired,
  shortListedHotels: PropTypes.array.isRequired,
  searchRequest: PropTypes.object.isRequired,
};

export default HotelWhatsAppShareModal;
